module.exports = __webpack_public_path__ + "static/media/Dosis-ExtraBold.b6d17f25.ttf";